// src/App.js
import React, { useState, useEffect } from 'react';
import { getCurrentUser, signOut } from '@aws-amplify/auth';
import Login from './components/Login';
import Chat from './components/Chat/Chat';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      await getCurrentUser();
      setIsAuthenticated(true);
    } catch (err) {
      setIsAuthenticated(false);
    }
  };

  const handleLogout = async () => {
    await signOut();
    setIsAuthenticated(false);
  };

  return (
    <div>
      {isAuthenticated ? (
        <Chat onLogout={handleLogout} />  // Pass handleLogout as a prop
      ) : (
        <Login onLogin={() => setIsAuthenticated(true)} />
      )}
    </div>
  );
};

export default App;